export default {
	all (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'color/all', params)
	},
	one (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'color/one', params)
	}
}



// WEBPACK FOOTER //
// ./src/api/Color.js